module.exports = __webpack_public_path__ + "static/media/bolt.57209c41.svg";